const styles = () => ({
  root: {
    position: 'relative',
    display: 'inline-block'
  },
  actualText: {
    display: 'inline-block'
  },
  overlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    overflow: 'hidden',
    display: 'inline-block',
    opacity: 0
  },
  overlayText: {},
  hidden: {
    opacity: 0
  },
  animating: {
    '& $actualText': {
      opacity: 0
    },
    '& $overlay': {
      opacity: 1
    }
  }
});

export { styles };

// Commit trace: 2025-10-08T19:34:08 - fix: resolve minor issue in Text.styles.js

// Commit trace: 2026-02-16T04:57:03 - fix: resolve minor issue in Text.styles.js

// Commit trace: 2026-02-16T19:55:12 - refactor: modularize helper functions in Text.styles.js

// Commit trace: 2026-02-21T05:28:20 - docs: clarify parameter types in Text.styles.js
